// LP Quiz-First Funnel — orchestrateur 4 étapes
(function () {
  'use strict';

  const STEPS = ['hero', 'quiz', 'transition', 'results'];
  const STORAGE_KEY = 'mts_quiz_answers';

  const state = {
    answers: { audience: null, style: null, team: null, size: null },
    currentQ: 1,
    totalQ: 4,
  };

  const $step = (name) => document.querySelector(`[data-quiz-step="${name}"]`);
  const $all = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function showStep(name) {
    STEPS.forEach((s) => {
      const el = $step(s);
      if (!el) return;
      el.hidden = s !== name;
    });
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }

  function showQuestion(idx) {
    const widget = $step('quiz');
    if (!widget) return;
    state.currentQ = idx;
    $all('[data-quiz-question]', widget).forEach((q) => {
      q.hidden = Number(q.dataset.quizIndex) !== idx;
    });
    const progress = widget.querySelector('[data-quiz-progress]');
    if (progress) progress.style.width = (idx / state.totalQ) * 100 + '%';
    const count = widget.querySelector('[data-quiz-count]');
    if (count) count.textContent = `${idx} / ${state.totalQ}`;
    const back = widget.querySelector('[data-quiz-back]');
    if (back) back.disabled = idx === 1;
  }

  function persist() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state.answers));
    } catch (e) {}
  }

  function restore() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) Object.assign(state.answers, JSON.parse(raw));
    } catch (e) {}
  }

  // === HERO ===
  function bindHero() {
    $all('[data-quiz-start]').forEach((btn) => {
      btn.addEventListener('click', () => {
        showStep('quiz');
        showQuestion(1);
      });
    });
  }

  // === WIDGET (4 questions) ===
  function bindQuiz() {
    const widget = $step('quiz');
    if (!widget) return;

    $all('[data-quiz-question]', widget).forEach((q) => {
      const key = q.dataset.quizQuestion;
      $all('[data-quiz-answer]', q).forEach((opt) => {
        opt.addEventListener('click', () => {
          $all('.lp-quiz-opt', q).forEach((o) => o.classList.remove('is-selected'));
          opt.classList.add('is-selected');
          state.answers[key] = opt.dataset.quizAnswer;
          persist();

          // Auto-advance après 200ms
          setTimeout(() => {
            const idx = Number(q.dataset.quizIndex);
            if (idx < state.totalQ) {
              showQuestion(idx + 1);
            } else {
              startTransition();
            }
          }, 200);
        });
      });
    });

    const back = widget.querySelector('[data-quiz-back]');
    if (back) {
      back.addEventListener('click', () => {
        if (state.currentQ > 1) showQuestion(state.currentQ - 1);
      });
    }
  }

  // === TRANSITION ===
  function startTransition() {
    showStep('transition');
    const checks = $all('[data-quiz-check]');
    checks.forEach((c) => c.classList.remove('is-done'));
    let i = 0;
    const interval = Math.max(500, Math.min(1000, 2800 / Math.max(1, checks.length)));
    const tick = () => {
      if (i < checks.length) {
        checks[i].classList.add('is-done');
        i += 1;
        setTimeout(tick, interval);
      } else {
        setTimeout(showResults, 400);
      }
    };
    tick();
  }

  // === RESULTS ===
  function showResults() {
    showStep('results');
    renderResults();
  }

  function renderResults() {
    const results = $step('results');
    if (!results) return;

    const titleEl = results.querySelector('[data-quiz-results-title]');
    const grid = results.querySelector('[data-quiz-results-grid]');
    const empty = results.querySelector('[data-quiz-results-empty]');
    if (!grid) return;

    const buckets = $all('[data-quiz-bucket]', grid);
    const styleAns = state.answers.style || 'any';
    const teamAns = (state.answers.team || 'any').toLowerCase();

    let visibleCount = 0;
    buckets.forEach((b) => {
      const bStyle = (b.dataset.bucketStyle || 'any').toLowerCase();
      const bTeam = (b.dataset.bucketTeam || 'any').toLowerCase();

      const styleOk = bStyle === 'any' || bStyle === styleAns;
      const teamOk =
        bTeam === 'any' ||
        bTeam === teamAns ||
        teamAns === 'discover' ||
        teamAns === 'any';

      const show = styleOk && teamOk;
      b.hidden = !show;
      if (show) visibleCount += b.querySelectorAll('.lp-quiz-product').length;
    });

    // Pré-sélectionner la taille du quiz dans chaque produit
    if (state.answers.size) {
      $all('[data-quiz-size-select]', results).forEach((sel) => {
        const want = state.answers.size.toLowerCase();
        const opt = Array.from(sel.options).find((o) =>
          o.textContent.toLowerCase().includes(want)
        );
        if (opt) sel.value = opt.value;
      });
    }

    if (titleEl) {
      const base = titleEl.textContent.trim();
      titleEl.textContent = visibleCount
        ? `${base} (${visibleCount} maillot${visibleCount > 1 ? 's' : ''} trouvé${visibleCount > 1 ? 's' : ''})`
        : base;
    }

    if (empty) empty.hidden = visibleCount > 0;

    bindAtcForms(results);
  }

  function bindAtcForms(scope) {
    $all('[data-quiz-atc-form]', scope).forEach((form) => {
      if (form.__bound) return;
      form.__bound = true;
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        const btn = form.querySelector('button[type="submit"]');
        const original = btn ? btn.textContent : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Ajout...';
        }
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: fd,
            headers: { Accept: 'application/json' },
          });
          if (!res.ok) throw new Error('atc failed');
          if (btn) btn.textContent = '✓ Ajouté';
          setTimeout(() => {
            window.location.href = '/cart';
          }, 600);
        } catch (err) {
          if (btn) {
            btn.disabled = false;
            btn.textContent = original;
          }
        }
      });
    });
  }

  function init() {
    restore();
    bindHero();
    bindQuiz();
    showStep('hero');
    showQuestion(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
